import { cn } from '@/lib/utils';
import { useEffect, useState } from 'react';

const formatVND = (amount: number) => new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(amount);

interface BookingPriceRailProps {
  minPrice: number | null;
  onBook: () => void;
  className?: string;
}

export function BookingPriceRail({ minPrice, onBook, className }: BookingPriceRailProps) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const target = document.getElementById('packages');
    if (!target) return;
    const observer = new IntersectionObserver(([entry]) => setHidden(entry.isIntersecting), {
      rootMargin: '-80px 0px 0px 0px',
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  if (hidden) return null;

  return (
    <div className={cn('sticky top-36 rounded-xl border border-(--pill-border) bg-white p-5 shadow-(--shadow-card)', className)}>
      {minPrice !== null && (
        <div className="mb-4">
          <p className="text-muted-foreground text-xs">Từ</p>
          <p className="text-2xl font-bold text-gray-900">{formatVND(minPrice)}</p>
        </div>
      )}
      <button
        onClick={onBook}
        className="bg-primary w-full rounded-xl py-3 text-sm font-semibold text-white transition-colors hover:bg-(--brand-orange-hover)"
      >
        Chọn các gói dịch vụ
      </button>
    </div>
  );
}
